// Mission-control banner is served locally from /public/platform as optimized
// WebP (~52/88 KB) instead of the original ~1.5/1.8 MB Lovable CDN PNGs (which
// also 404 off mane.dev).

/**
 * Brain section — full-width marble/governance banner with overlay copy.
 */
const BrainMCP = () => {
  return (
    <section className="py-12 sm:py-16">
      <div className="mx-auto px-5 sm:px-8" style={{ maxWidth: 2048 }}>
        <div
          className="relative w-full overflow-hidden brain-banner"
          style={{
            aspectRatio: "2048 / 682",
            backgroundImage: 'url("/platform/mission-control-banner.webp")',
            backgroundSize: "cover",
            backgroundPosition: "center right",
          }}
        >
          {/* Readability overlay */}
          <div
            aria-hidden
            className="absolute inset-0 pointer-events-none brain-banner-overlay"
          />

          <div className="brain-banner-text">
            <h2 className="brain-banner-headline">
              AI agents for your
              <br />
              most <span className="brain-banner-accent">critical work.</span>
              <br />
              You stay in control.
            </h2>
            <p className="brain-banner-sub">
              Set up around how <span className="brain-banner-sub-accent">your business</span> runs.
            </p>
          </div>
        </div>
      </div>

      <style>{`
        .brain-banner {
          border-radius: 28px;
          transform: translateY(-4px);
          box-shadow: 0 0 0 1px hsl(var(--foreground) / 0.06);
        }
        .brain-banner-overlay {
          background: linear-gradient(90deg, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.76) 38%, rgba(255,255,255,0.18) 64%, rgba(255,255,255,0) 100%);
        }
        :root.dark .brain-banner {
          box-shadow: 0 0 0 1px hsl(var(--foreground) / 0.10);
        }
        :root.dark .brain-banner-overlay {
          background: linear-gradient(90deg, rgba(10,10,10,0.92) 0%, rgba(10,10,10,0.76) 38%, rgba(10,10,10,0.22) 64%, rgba(10,10,10,0) 100%);
        }
        .brain-banner-text {
          position: absolute;
          left: 7%;
          top: 50%;
          transform: translateY(-50%);
          max-width: 52%;
        }
        .brain-banner-headline {
          font-family: Inter, Geist, system-ui, -apple-system, sans-serif;
          font-weight: 400;
          letter-spacing: -0.035em;
          line-height: 1.05;
          color: #1f222b;
          font-size: clamp(22px, 2.6vw, 52px);
          margin: 0;
        }
        :root.dark .brain-banner-headline { color: #ffffff; }
        .brain-banner-accent {
          background: linear-gradient(90deg, #e99a5e 0%, #c7753f 100%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        :root.dark .brain-banner-accent {
          background: none;
          -webkit-background-clip: unset;
          background-clip: unset;
          color: #ffffff;
        }
        .brain-banner-sub {
          margin-top: clamp(10px, 1.2vw, 18px);
          font-size: clamp(12px, 0.95vw, 19px);
          line-height: 1.4;
          font-weight: 400;
          letter-spacing: -0.015em;
          color: #2f3340;
          max-width: 92%;
        }
        :root.dark .brain-banner-sub { color: #ffffff; }
        .brain-banner-sub-accent { color: #d98247; font-weight: 400; }
        :root.dark .brain-banner-sub-accent { color: #ffffff; }

        @media (max-width: 1024px) {
          .brain-banner { border-radius: 22px; }
          .brain-banner-text { left: 6%; max-width: 56%; }
          .brain-banner-headline { font-size: clamp(20px, 3.4vw, 34px); }
          .brain-banner-sub { font-size: clamp(11px, 1.4vw, 14px); }
        }
        @media (max-width: 640px) {
          .brain-banner {
            border-radius: 16px;
            aspect-ratio: 941 / 2000;
            min-height: 560px;
            max-height: none;
            background-image: url(/platform/mission-control-banner-mobile.webp) !important;
            background-position: center center;
            background-size: cover;
          }
          .brain-banner-overlay {
            background: linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.25) 22%, rgba(255,255,255,0) 40%) !important;
          }
          :root.dark .brain-banner-overlay {
            background: linear-gradient(180deg, rgba(10,10,10,0.78) 0%, rgba(10,10,10,0.42) 22%, rgba(10,10,10,0) 40%) !important;
          }
          .brain-banner-text {
            position: absolute;
            left: 18px;
            right: 18px;
            top: 50%;
            transform: translateY(-50%);
            max-width: none;
            text-shadow: 0 1px 10px rgba(255,255,255,0.7);
          }
          :root.dark .brain-banner-text {
            text-shadow: 0 2px 16px rgba(0,0,0,0.9), 0 1px 6px rgba(0,0,0,0.7);
          }
          .brain-banner-headline { font-size: clamp(30px, 9vw, 42px); line-height: 1.08; }
          .brain-banner-sub { font-size: 16px; max-width: none; margin-top: 22px; }
        }
      `}</style>
    </section>
  );
};

export default BrainMCP;
